import { Navigate, Outlet } from "react-router-dom";
import useAuthStore from "../store/authStore";

const LoginProtect = () => {
  const { refToken, isAuthenticated, userType } = useAuthStore();

  if (refToken && isAuthenticated && userType === "admin") {
    return <Navigate to="/" replace />;
  } else if (refToken && isAuthenticated && userType === "manager") {
    return <Navigate to="/manager" replace />;
  } else {
    return <Outlet />;
  }
};

export default LoginProtect;
